import { render, staticRenderFns } from "./dokumentasi.vue?vue&type=template&id=73157836&scoped=true&"
import script from "./dokumentasi.vue?vue&type=script&lang=js&"
export * from "./dokumentasi.vue?vue&type=script&lang=js&"
import style0 from "./dokumentasi.vue?vue&type=style&index=0&id=73157836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73157836",
  null
  
)

export default component.exports